import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

interface IProps {
  onLogin: Function;
}

interface IFormInputs {
  username: string;
  password: string;
  rememberMe: boolean;
}

const validationSchema = yup.object().shape({
  username: yup
    .string()
    .email('Username must be a valid email')
    .required('Username is required'),
});

const LoginForm: React.FC<IProps> = ({ onLogin }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormInputs>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = (values: IFormInputs) => {
    onLogin(values);
  };

  return (
    <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="space-y-6">
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                Email address
              </label>
              <div className="mt-1 relative">
                <input
                  {...register('username')}
                  id="username"
                  autoComplete="email"
                  className={`${
                    errors.username
                      ? `border-red-300 placeholder-red-300 focus:ring-red-500 focus:border-red-500`
                      : `border-gray-300 placeholder-gray-400 focus:ring-primary-light focus:border-primary-light`
                  } appearance-none block w-full px-3 py-2 border  rounded-md shadow-sm  focus:outline-none  sm:text-sm`}
                />
                {errors.username ? (
                  <div className="absolute inset-y-0 -top-7 right-0 pr-3 flex items-center pointer-events-none">
                    {/* Heroicon name: solid/exclamation-circle */}
                    <svg
                      className="h-5 w-5 text-red-500"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                ) : null}
                <p className="mt-2 text-sm text-red-600">
                  {errors.username?.message}
                </p>
              </div>
            </div>
            <div>
              <button
                type="submit"
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-light"
              >
                Send Sign In Link
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
